<template>
    <accordion-section title="Season" :loading="loading">
        <b-field horizontal label="Season">
            <b-select v-model="product.season_id" expanded disabled>
                <option value="">-</option>
                <option v-for="season in seasons"
                        :key="`season-option-${season.id}`"
                        :value="season.id"
                        v-text="season.name"></option>
            </b-select>
        </b-field>
    </accordion-section>
</template>

<script>
    export default {
        props: {
            product: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: true,
                seasons: []
            }
        },
        mounted() {
            axios.get('/season/index')
                .then(response => {
                    this.seasons = response.data;
                    this.loading = false;
                })
        }
    }
</script>